<template>
    <div class="personalMain">
        <p class="current">当前位置：<span>我的团队</span></p>
        <div class="integral-box">
            <Menu></Menu>
            <div class="MainInfo-inte">
                <p class="currTitle">我的团队</p>
                <div class="teams-box">
                    <div>
                        
                        <span>我的直推</span>
                        <p>{{ TeamsTotal.total2 }}</p>
                    </div>
                    <div>
                        <span>我的团队</span>
                        <p>{{ TeamsTotal.total }}</p>
                    </div>
                   
                </div>
                <div class="inte-context">
                    <div class="teams-Item" v-for="(item,index) in TeamsList" :key="index" v-if="TeamsList != ''">
                        <div style="display: flex;justify-content: flex-start;align-items: center;">
                            <p v-if="!(item.name=='')">{{item.name}}</p>
                            <p style="margin-left: 20px;font-size: 16px; color: #666666;">注册时间：{{ item.insert_time }}</p>
                        </div>
                        
                        <div class="teamsInfo">
                            <div>
                                <p>{{item.user_mobile}}</p>
                                <p>ID:{{item.user_id}}</p>
                                <p>会员级别：{{item.user_level}}</p>
                                
                            </div>
                            <div>
                                
                            
                                <p>累计交易：{{item.buyTotal}}</p>
                                <p>贡献收益：{{item.profitTotal}}</p>
                                <p>下级：{{item.subpn}}</p>
                            </div>
                            
                            

                        </div>
                    </div>
                    <div v-if="TeamsList == ''" class="teamsNull">
                        <p>亲，未找到记录~</p>
                    </div>
                
                </div>
                
            </div>
            <div class="pagination">
                <el-pagination
                    :hide-on-single-page="hideOnSinglePage"
                    :page-size="20"
                    :pager-count="widthNew?11:5"
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
         
        </div>
    </div>
</template>

<script>
import Menu from './index.vue'
export default{
    data(){
        return{
            total: 0,
            hideOnSinglePage: true,
            TeamsTotal: {},
            TeamsList: [],
            widthNew: false
        }
    },
    components:{
        Menu
    },
    methods: {
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            
        },
        getDateTime(timeDate){
            const year = timeDate.getFullYear();
            const month = (timeDate.getMonth() + 1).toString().padStart(2, '0');
            const day = timeDate.getDate().toString().padStart(2, '0');
            const hours = timeDate.getHours().toString().padStart(2, '0');
            const minutes = timeDate.getMinutes().toString().padStart(2, '0');
            const seconds = timeDate.getSeconds().toString().padStart(2, '0');
            const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

            return formattedDate
        },
    },  
    mounted(){
        
        let data = {}
        this.$store.dispatch('personal/getTeamsByUser',data)
            .then(res => {
                if(res.ok){
                   this.TeamsTotal = res.data

                }
            })
        
        let TeamsData = {
            pageNum: '1',
            pageSize: '20'
        }
        this.$store.dispatch('personal/listSubUser',TeamsData)
            .then(res => {
                if(res.ok){
                    this.TeamsList = res.data.items

                    this.total = res.data.total
                    this.integralList = res.data.items
                    this.TeamsList.forEach(item => {
                        const timeDate = new Date(item.insert_time)
                        item.insert_time = this.getDateTime(timeDate)
                    });
                    
                    if(this.total <= 10){
                        this.hideOnSinglePage = true
                    }else{
                        this.hideOnSinglePage = false
                    }
                }
            })
    },
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        localStorage.setItem('active','2-4')
    }
}
</script>

<style>
/* @import url(../../css/personal.css); */
</style>

<style scoped>
.MainInfo-inte{
    width: 910px;min-height: 700px;
    padding: 20px 20px;
    margin-left: 20px;
    background: #fff;
}
.teams-box{
  padding-left: 10px;
  padding-bottom: 15px;
  border-bottom: 0.5px solid #f2f2f2;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  margin-top: 20px;
}
.teams-box div{
    margin: 0px 150px;
    text-align: center;
}
.teams-box p{
  font-size: 28px;
  font-weight: 700;
  margin-top: 6px;
}
.teams-box span{
  font-size: 16px;
  color: #666666;
}


.teams-Item{
  margin-top: 20px;
  padding-bottom: 20px;
  padding-left: 10px;
  border-bottom: 0.5px solid #f2f2f2;
  font-size: 22px;
}
.teamsInfo{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
}
.teamsInfo div{
    width: 47%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-left: 20px;
}
.teamsInfo p{
    font-size: 16px;
    color: #666666;
    line-height: 25px;
}
.teamsNull{
    font-size: 18px;
    color: #666666;
    text-align: center;
    margin-top: 40px;
}

.currTitle{
    padding: 10px 10px;
    font-size: 22px;
    font-weight: 700px;
    border-bottom: 0.5px solid #f2f2f2;
}

@media screen and (min-width: 541px) {
    .integral-box{
        width: 1200px;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
    }
}
@media screen and (max-width: 540px) {
    .integral-box{
        width: 96%;
        margin: 15px auto;
    }
    .MainInfo-inte{
        width: 100%;
        padding: 20px 0px;
    }
    .currTitle{
        padding: 5px 10px;
        font-size: 20px;
        
    }

    .teams-box{
        padding-left: 0px;
        font-size: 20px;
    }
    .teams-box div{
        margin: 0px 50px;
    }
    .teams-box p{
        font-size: 26px;
    }
    .teams-box span{
        font-size: 14px;
        color: #666666;
    }
    
    .teams-Item{
        padding-left: 0px;
        font-size: 20px;
    }

}
</style>